import { BRAND } from '@crew/shared';
import type { ReactNode } from 'react';
import { BrandLogoFull } from '../brand/BrandLogo';

/**
 * המעטפת הממותגת של מסכי הקבלן (קישור הרשמה וקישור אישי).
 * הקבלן רואה את הלוגו המלא של החברה בראש הדף, כרטיס לבן ממורכז,
 * ופס כחול-לילה עם פרטי החברה בתחתית.
 */
export function ContractorLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col bg-paper">
      <div className="h-1.5 bg-brand" aria-hidden="true">
        <div className="mx-auto h-full w-24 bg-accent" />
      </div>
      <header className="flex justify-center px-5 pb-2 pt-8">
        <BrandLogoFull height={132} />
      </header>
      <main className="flex-1 px-4 pb-10 pt-4">
        <div className="mx-auto w-full max-w-md rounded-card border border-line bg-surface p-5 shadow-[0_1px_0_var(--color-line)] sm:p-7">
          {children}
        </div>
      </main>
      <footer className="pb-safe bg-brand px-5 py-4 text-center text-[13px] text-steel">
        <span className="font-bold text-white">{BRAND.name}</span>
        <span className="mx-2 text-white/30" aria-hidden="true">|</span>
        {BRAND.tagline}
      </footer>
    </div>
  );
}
